import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareNodes, faHeart } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { addToWishlist, RemoveWishlist } from "../../features/wishlistSlice";
import { fetchWishlists } from "../../features/fetchwishListitem";
import Facebookicon from "../../assets/new-images/facebook-icon.png";
import Copyicon from "../../assets/new-images/copy-icon.png";
import Whatsappicon from "../../assets/new-images/whatsapp-icon.png";
import { addToCart } from "../../features/cartSlice";
import { FacebookShareButton, WhatsappShareButton } from "react-share";
import {
  addToCompare,
  removeFromCompare,
} from "../../features/compareSlicetwo";
import { fetchCartItems } from "../../features/cartitemsSlice";
import { toast } from "react-toastify";
import axios from "axios";
import { apiurl } from "../../Constants";
import { removeFromCart } from "../../features/cartSlice";
function Productgrid({ items, productdetailslink }) {
  const [hovered, setHovered] = useState(false);
  const [loading, setLoading] = useState(false);
  const [color, setColor] = useState("#ffad00");
  const [addedToCart, setAddedToCart] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const debounceTimeout = useRef(null);

  const user_id = localStorage.getItem("userId");

  const [quantity, setQuantity] = useState(1);

  const { items: wishlistitems } = useSelector((state) => state.wishlistItems);

  const { items: cartitems } = useSelector((state) => state.cartitems);

  const deleteCart = (product_id) => {
    dispatch(removeFromCart({ user_id, product_id }));
  };

  const isInWishlist = (product_id) => {
    return (
      wishlistitems &&
      wishlistitems.some((wishlistItem) => wishlistItem.id === product_id)
    );
  };

  // const IsinCart = (product_id) => {
  //   return cartitems && cartitems.some((items) => items.id === product_id);
  // };

  const IsinCart = (product_id) => {
    if (user_id) {
      return cartitems && cartitems.some((items) => items.id === product_id);
    } else {
      return sessionCart.some((item) => item.product_id === product_id);
    }
  };

  useEffect(() => {
    if (cartitems && items) {
      const cartItem = cartitems.find((cartdata) => cartdata.id === items.id);
      if (cartItem) {
        setQuantity(cartItem.quantity);
      } else {
        setQuantity(1);
      }
    }
  }, [cartitems, items]);

  const handleAddtoWishlist = (product_id) => {
    if (!user_id) {
      navigate("/login");
      return;
    }
    dispatch(addToWishlist({ product_id, user_id }));
    dispatch(fetchWishlists(user_id));
  };

  const handleRemoveFromWishlist = (product_id) => {
    dispatch(RemoveWishlist({ product_id }));
    dispatch(fetchWishlists(user_id));
  };

  const [sessionCart, setSessionCart] = useState(
    JSON.parse(sessionStorage.getItem("temp_cart")) || []
  );

  const handleAddToCart = (item) => {
    if (!user_id) {
      const tempCart = JSON.parse(sessionStorage.getItem("temp_cart")) || [];

      const newCart = [
        ...tempCart,
        {
          product_id: item.id,
          quantity: quantity,
        },
      ];

      sessionStorage.setItem("temp_cart", JSON.stringify(newCart));
      setSessionCart(newCart); // ✅ This triggers re-render
      return;
    }

    // existing logic for logged-in user
    setLoading(true);
    dispatch(addToCart({ user_id, product_id: item.id, quantity: quantity }))
      .then(() => {
        setLoading(false);
        setAddedToCart(true);
      })
      .catch(() => {
        setLoading(false);
      });
    dispatch(fetchCartItems(user_id));
  };

  const { compareProductIds } = useSelector((state) => state.compare);

  const handleCompareChange = (productId) => {
    if (compareProductIds.includes(productId)) {
      dispatch(removeFromCompare(productId));
    } else {
      dispatch(addToCompare(productId));
    }
  };

  const handleMouseEnter = () => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    setHovered(true);
  };

  const handleMouseLeave = () => {
    debounceTimeout.current = setTimeout(() => {
      setHovered(false);
    }, 50);
  };

  const increaseQuantity = (productQuantity) => {
    if (quantity < productQuantity) {
      setQuantity(quantity + 1);
    } else {
      toast.error(
        `Your Selected Order Quantity is Greater than our Existing Stock`
      );
    }
  };

  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    } else {
      toast.error(`You must purchase at least 1 of this product.`);
    }
  };

  const updateCart = async (product_id, updatedQty) => {
    localStorage.removeItem("couponDetails");
    try {
      await axios.post(apiurl + "cart_quantity_update", {
        user_id: user_id,
        product_id: product_id,
        quantity: updatedQty,
      });
      dispatch(fetchCartItems(user_id));
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  const DecreaseQuantitys = (product_id, product_quantity) => {
    if (user_id) {
      const cartItems = cartitems.find((item) => item.id === product_id);

      if (cartItems) {
        var currentQty = cartItems.quantity;

        if (currentQty > 1) {
          const updatedQty = currentQty - 1;
          updateCart(product_id, updatedQty);
        } else {
          deleteCart(product_id);
        }
      }
    } else {
      navigate("/login");
    }
  };

  const IncreaseQuantitys = (product_id, product_quantity) => {
    if (user_id) {
      dispatch(fetchCartItems(user_id));

      const cartItems = cartitems.find((item) => item.id === product_id);

      if (cartItems) {
        var currentQty = cartItems.quantity;

        if (currentQty < product_quantity) {
          const updatedQty = currentQty + 1;
          updateCart(product_id, updatedQty);
        } else {
          toast.error(
            `Your Selected Order Quantity is Greater than Our Existing Stock`
          );
        }
      }
    } else {
      navigate("/login");
    }
  };

  useEffect(() => {
    const tempCart = JSON.parse(sessionStorage.getItem("temp_cart"));
    if (user_id && tempCart && tempCart.length > 0) {
      tempCart.forEach((item) => {
        dispatch(
          addToCart({
            user_id,
            product_id: item.product_id,
            quantity: item.quantity,
          })
        );
      });
      sessionStorage.removeItem("temp_cart");
      dispatch(fetchCartItems(user_id));
    }
  }, [user_id]);

  return (
    <div className="card inner-box product_grid-1" style={{ border: "0" }}>
      <div
        className="img_box"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Link to={productdetailslink}>
          <img
            src={
              hovered
                ? items.product_image[1] || items.product_image[0]
                : items.product_image[0]
            }
            alt="img"
          />
        </Link>
        <div className="share_icon_inner_box">
          <FontAwesomeIcon icon={faShareNodes} className="share_icon" />
          <div className="social_icons">
            <FacebookShareButton
              url={`https://my.aammii.com/product-details/${items.id}`}
              quote={items.product_name}
            >
              <img src={Facebookicon} alt="Share on Facebook" />
            </FacebookShareButton>

            <WhatsappShareButton
              url={`https://my.aammii.com/product-details/${items.id}`}
              separator=":: "
            >
              <img src={Whatsappicon} alt="Share on WhatsApp" />
            </WhatsappShareButton>

            <span
              onClick={() =>
                navigator.clipboard.writeText(
                  `https://my.aammii.com/product-details/${items.id}`
                )
              }
            >
              <img src={Copyicon} alt="Copy URL" />
            </span>
          </div>
        </div>

        <div className="wishlist_box">
          <button
            className={
              isInWishlist(items.id)
                ? "wishlist_btn_active"
                : "wishlist_btn_inactive"
            }
            onClick={() => {
              if (isInWishlist(items.id)) {
                handleRemoveFromWishlist(items.id);
              } else {
                handleAddtoWishlist(items.id);
              }
            }}
          >
            <FontAwesomeIcon icon={faHeart} />
          </button>
        </div>
      </div>

      <div className="card" style={{ border: "0" }}>
        <div className="content_box text-center">
          <h6>{items.product_name}</h6>
          {items.discount_price == 0 ? (
            <>
              <del style={{ visibility: "hidden" }}>
                RM {items.actual_price}
              </del>
              <h5>RM {items.actual_price}</h5>
            </>
          ) : (
            <>
              <del
                style={{
                  visibility:
                    items.actual_price === items.discount_price
                      ? "hidden"
                      : "visible",
                }}
              >
                RM {items.actual_price}
              </del>
              <h5>RM {items.discount_price}</h5>
            </>
          )}
        </div>

        <div className="btn_main_box">
          <div className="btn_box">
            {IsinCart(items.id) ? (
              <>
                <div className="quantity-control update_carts">
                  <button
                    className="quantity-button"
                    onClick={() =>
                      DecreaseQuantitys(items.id, items.product_quantity)
                    }
                  >
                    -
                  </button>
                  <div className="quantity-display">{quantity}</div>
                  <button
                    className="quantity-button"
                    onClick={() =>
                      IncreaseQuantitys(items.id, items.product_quantity)
                    }
                  >
                    +
                  </button>
                </div>
              </>
            ) : (
              <div className="quantity-control normal_update">
                <button
                  className="quantity-button"
                  onClick={() => decreaseQuantity(items.product_quantity)}
                >
                  -
                </button>
                <div className="quantity-display">{quantity}</div>

                <button
                  className="quantity-button"
                  onClick={() => increaseQuantity(items.product_quantity)}
                >
                  +
                </button>
              </div>
            )}
            {IsinCart(items.id) ? (
              <button
                className="btn_1_1 go_to_cart_btn"
                onClick={() => {
                  navigate("/cart");
                }}
                style={{ textDecoration: "none" }}
              >
                Go to Cart
              </button>
            ) : (
              <button
                className="btn_1_1"
                onClick={() => handleAddToCart(items)}
                disabled={loading || addedToCart}
              >
                {loading ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                ) : (
                  "Add to Cart"
                )}
              </button>
            )}
          </div>

          <div className="compare_box">
            <input
              type="checkbox"
              checked={compareProductIds.includes(items.id)}
              onChange={() => handleCompareChange(items.id)}
            />
            <label>
              {compareProductIds.includes(items.id)
                ? "Remove  Compare"
                : "Add to Compare"}
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Productgrid;
